export default "__VITE_ASSET__BeUJylDX__"